import React, {Fragment, useMemo, useState} from "react";
import Selector from "../../../../components/selector";
import EnhancedModal from "../../../../components/enhanced-modal";
import {Button} from "antd";
import {GUTTER_MD, MODAL_WIDTH_LG, TABLE_COL_MIN_WIDTH_ID} from "../../../../styles/constants";
import InfiniteScrollTable from "../../../../components/infinite-scroll-table";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {datasetBuilderGetTableView, getDatasets, selectConnectionDatasetBuilder} from "../actions";
import {datasetBuilderEraseUpdateInDb, replaceQueryDatasetBuilder} from "./actions";

const mapStateToProps = (state) => ({
    connId: state.scenes.mappingHandler.datasetBuilder.index.connId,
    connections: state.scenes.mappingHandler.datasetBuilder.index.connections,
    username: state.app.user.username,
});

const mapDispatchToProps = dispatch => ({
    onConnectionSelection: (connId) => dispatch(selectConnectionDatasetBuilder(connId)),
    getDatasets: (connId, username) => dispatch(getDatasets(connId, username)),
    getTableViews: (connId) => dispatch(datasetBuilderGetTableView(connId)),
    resetUpdateInDbData: () => dispatch(datasetBuilderEraseUpdateInDb()),
    resetQuery: () => dispatch(replaceQueryDatasetBuilder(""))
});

const ConnectionSelector = ({t, connId, connections, onConnectionSelection, resetUpdateInDbData, getDatasets, getTableViews, username, disableModify, style = {}, resetQuery}) => {
    const [showModal, setShowModal] = useState(false);
    const selectedConnection = useMemo(() => (connections || []).find(item => item.entityId === connId), [connections, connId]);
    return <Fragment>
        <div style={{display: "flex", justifyContent: "flex-end", alignItems: "center", whiteSpace: "nowrap", gap: GUTTER_MD}}>
            <span>{t('scenes.mappingHandler.DatasetBuilder.connectionSelector.selectorTitle')}:</span>
        <Selector
            value={selectedConnection ? `${selectedConnection.connectionName}+${selectedConnection.database}+${selectedConnection.dbTypeDescription}` : null}
            selectTitle={t('scenes.mappingHandler.DatasetBuilder.connectionSelector.selectButton.title')}
            resetTitle={t('scenes.mappingHandler.DatasetBuilder.connectionSelector.resetButton.title')}
            onSelect={() => setShowModal(true)}
            onReset={() => onConnectionSelection(null)}
            style={style}
            disabled={disableModify}
        />
        </div>
        <EnhancedModal
            visible={showModal}
            title={t('scenes.mappingHandler.DatasetBuilder.connectionSelector.title')}
            footer={<Button
                onClick={() => setShowModal(false)}>{t('commons.buttons.close.title')}</Button>}
            onCancel={() => setShowModal(false)}
            width={MODAL_WIDTH_LG}
        >
            <InfiniteScrollTable
                data={connections || []}
                getRowKey={({name}) => name}
                columns={[
                    {
                        title: t('data.datasetBuilder.modals.connectionName.label'),
                        dataIndex: 'connectionName',
                        minWidth: TABLE_COL_MIN_WIDTH_ID
                    },
                    {
                        title: t('data.datasetBuilder.modals.dbName.label'),
                        dataIndex: 'database',
                        minWidth: TABLE_COL_MIN_WIDTH_ID,
                    },
                    {
                        title: t('data.datasetBuilder.modals.dbType.label'),
                        dataIndex: 'dbTypeDescription',
                        minWidth: TABLE_COL_MIN_WIDTH_ID,
                    },
                ]}
                onRowClick={({entityId}) => {
                    onConnectionSelection(entityId)
                    resetUpdateInDbData();
                    resetQuery();
                    getDatasets(entityId, username);
                    getTableViews(entityId);
                    setShowModal(false);
                }}
            />
        </EnhancedModal>
    </Fragment>
};

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(ConnectionSelector);